"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _InputNumberRange = _interopRequireDefault(require("../InputNumberRange"));
var _treeSelect = _interopRequireDefault(require("../CostItemTableTree/treeSelect"));
var _default = exports.default = {
  name: 'BasisSearchForm',
  // 基础搜索表单组件
  components: {
    InputNumberRange: _InputNumberRange.default,
    CostItemTreeSelect: _treeSelect.default
  },
  props: {
    // form-model-item的配置数组
    items: {
      type: Array,
      default: () => {
        return [
          // {
          //   // Schema 定义
          //   key: 'title', // 确定这个列的唯一值,一般用于 dataIndex 重复的情况
          //   dataIndex: 'title', // 与实体映射的 key。valueType为dateRange时，可以把dataIndex设置为数组，如:['startDate', 'endDate']，将返回 {startDate:'2022-08-19', endDate: '2022-08-20'}
          //   valueType: 'input', // 数据的渲染方式
          //   daysRange: undefined, // valueType为dateRange时专有的属性，表示允许选择的天数跨度范围，如：30表示最多一共可以选择30天
          //   recentDays: undefined, // valueType为dateRange时专有的属性，表示允许选择最近recentDays天，如：30表示只能选择最近30天
          //   title: '标题', // 标题的内容，在 form 中是 label
          //   tooltip: undefined, // 会在 title 旁边展示一个 icon，鼠标悬浮时展示
          //   valueEnum: {}, // valueType为select时的枚举值, 支持 object 和 Map，Map 是支持其他基础类型作为 key
          //   formItemProps: {}, // 传递给 Form.Item 的配置，也可以是函数 formItemProps:(params)=>{return {}}
          //   fieldProps: {}, // 传递给组件（如 <a-input />）的配置，也可以是函数 fieldProps:(params)=>{return {}}
          //   defaultValue: undefined, // 默认值
          //   value: undefined, // 真实值，最终转换成提交给接口的参数值
          //   allowClear: true, // 是否允许清空
          //   width: '200px', // 宽度
          //   transform: (value, rawParams) => value, // value-当前字段的值，rawParams-未转换前的所有字段的{key,value}。对返回的结果进行转换
          //   request: undefined // 从远程请求网络数据（Promise请求），一般用于选择类组件 request: getDataList
          //   show: undefined // 是否显示，值为Boolean或function。show: (params)=>{ return params.name }。返回false时则该项不显示，一般用于实现表单联动
          // }
        ];
      }
    },
    // Form的props
    formProps: {
      type: Object,
      default: () => {}
    },
    // 是否显示label标题
    showLabel: {
      type: Boolean,
      default: true
    },
    // 收起时展示的Form.Item数量。没有配置该值时根据页面宽度进行自动适配
    limit: {
      type: Number,
      default: undefined // 为0时表示不限制，也不显示“收起/展开”按钮
    },
    // 组件的宽度
    fieldWidth: {
      type: String,
      default: '220px'
    },
    // 查询按钮是否固定在最右边
    btnFixedRight: {
      type: Boolean,
      default: false
    },
    // 是否显示loading状态
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      targetLimit: 2,
      formId: _.uniqueId('form-'),
      targetItems: [],
      // 经过初始化之后的 Form.Item 配置
      targetParams: {},
      // 参数对象
      collapse: true,
      // true-处于收起状态 false-处于展开状态
      shopLevelCacheMap: {},
      // 店铺层级ready时返回的value与index的映射关系{index:value}，用于重置时恢复数据
      curSelectedDate: [] // 日期选择组件当前选中值
    };
  },
  computed: {
    validItems() {
      // 通过sort字段进行排序，有值靠前，值越小越靠前，没值靠后。值相同则按传入的顺序
      const items = _.sortBy(this.targetItems, 'sort');
      return items.filter(item => {
        let {
          show
        } = item;
        if (typeof show === 'function') show = item.show(this.getResult(this.targetItems));
        return show !== false;
      });
    }
  },
  watch: {
    items: {
      handler(val) {
        this.init();
      },
      immediate: true,
      deep: true
    },
    validItems: {
      handler(val) {
        this.targetParams = this.getResult(val);
      },
      immediate: true,
      deep: true
    },
    targetParams: {
      handler(val, oldVal) {
        if (!_.isEqual(val, oldVal)) {
          this.$emit('update:params', this.targetParams);
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // 延时执行，确保表单节点已渲染完毕，能正常获取到clientWidth
    setTimeout(() => {
      if (this.limit !== undefined) {
        this.targetLimit = this.limit;
      } else {
        const formDom = document.getElementById(this.formId) || {};
        const clientWidth = formDom.clientWidth;
        // 74-label宽度 fieldWidth-输入框宽度 8-右边距 200-右侧按钮模块宽度
        const labelWidth = this.showLabel ? 74 : 0;
        const itemWidth = labelWidth + parseInt(this.fieldWidth) + 8;
        this.targetLimit = Math.floor((clientWidth - 200) / itemWidth);
      }
    });
  },
  methods: {
    // 点击“搜索”按钮
    search() {
      this.$emit('search', this.targetParams);
    },
    // 展开、收起
    handleCollapse() {
      this.collapse = !this.collapse;
      this.$emit('collapse', this.collapse);
    },
    /**
     * @description: 初始化、点击“重置”按钮
     * @param {string} type init-初始化完成 reset-点击“重置”按钮
     * @return {object} 最终用于请求的参数对象
     */
    init(type = 'init') {
      const {
        shopLevelCacheMap
      } = this;
      const requestMap = {};
      const items = _.cloneDeep(this.items);
      const res = items.map((item, index) => {
        const {
          defaultValue,
          value,
          valueType,
          request
        } = item;
        // 赋予默认值
        if (value === undefined && defaultValue !== undefined) item.value = defaultValue;

        // 赋予空数组-否则导致无法选择日期或输入
        if (['dateRange', 'numberRange'].includes(valueType) && !item.value) item.value = [];

        // request请求
        if (typeof request === 'function') requestMap[index] = request;

        // 重置时回填店铺层级初始化值
        if (type === 'reset' && valueType === 'shopLevel' && _.has(shopLevelCacheMap, index)) item.value = shopLevelCacheMap[index];

        // 重置时初始化选择科目
        if (type === 'reset' && valueType === 'costSelect') item.value = [];
        return item;
      });
      this.targetItems = res;

      // 获取request的值
      Object.keys(requestMap).forEach(async key => {
        const target = this.targetItems[key];
        const replaceFields = target.replaceFields || this.getTargetValue('fieldProps', target).replaceFields;
        const data = await requestMap[key]();

        // 数据格式替换
        if (replaceFields) {
          data.map(item => {
            Object.keys(replaceFields).forEach(field => {
              item[field] = item[replaceFields[field]];
            });
          });
        }
        target.options = data;
      });
      if (type === 'reset') {
        // 主动调用店铺层级组件清空搜索词接口
        const shopLevelRefs = this.$refs.basisShopLevelTreeSelect || [];
        shopLevelRefs.forEach(ref => ref.clearSearchValue());
        // 主动调用科目层级组件清空搜索词接口
        const costTreeRefs = this.$refs.costItemTreeSelect || [];
        costTreeRefs.forEach(ref => ref.clearSearchValue());
      }
      this.$emit(`${type}`, this.targetParams);
    },
    // 获取默认的props配置
    getDefaultProps(item) {
      const {
        fieldWidth
      } = this;
      const {
        options,
        allowClear,
        placeholder,
        title,
        valueType = 'input'
      } = item;
      let width = item.width || fieldWidth;
      if (!isNaN(width)) width += 'px';
      let actionStr = '输入';
      if (['select', 'infiniteSelect', 'shopLevel'].includes(valueType)) actionStr = '选择';
      const defaultStyle = valueType === 'shopLevel' ? {
        minWidth: width
      } : {
        width
      };
      const defaultProps = {
        options,
        style: defaultStyle,
        allowClear: allowClear === undefined ? true : allowClear,
        placeholder: placeholder || `${actionStr}${title}`
      };
      if (valueType === 'dateRange') {
        defaultProps.placeholder = placeholder || ['开始日期', '结束日期'];
        defaultProps.format = this.getTargetValue('fieldProps', item).format || item.format || 'YYYY-MM-DD';
        defaultProps.ranges = {
          昨天: [this.$moment().subtract(1, 'days'), this.$moment().subtract(1, 'days')],
          今天: [this.$moment(), this.$moment()],
          近7天: [this.$moment().subtract(6, 'days'), this.$moment()],
          本月: [this.$moment().startOf('month'), this.$moment()],
          // 本月只取到今天
          上个月: [this.$moment().subtract(1, 'months').startOf('month'), this.$moment().subtract(1, 'months').endOf('month')],
          近3个月: [this.$moment().subtract(2, 'months').startOf('month'), this.$moment()]
        };

        // 允许的天数范围
        const daysRange = item.daysRange || 0;
        const offsetDays = 86400000 * daysRange;

        // 允许选择最近recentDays天的日期，默认为365天
        const recentDays = item.recentDays || 365;
        defaultProps.disabledDate = current => {
          if (offsetDays > 0 && this.curSelectedDate[0]) {
            const currentDate = this.$moment(new Date(current.format(defaultProps.format)), defaultProps.format).valueOf();
            const selectedDate = this.$moment(this.curSelectedDate[0], defaultProps.format).valueOf();
            return currentDate > this.$moment(new Date(selectedDate + offsetDays), defaultProps.format) || currentDate < this.$moment(new Date(selectedDate - offsetDays), defaultProps.format) || current > this.$moment().endOf('day') || current < this.$moment().subtract(recentDays, 'days');
          }
          return current > this.$moment().endOf('day') || current < this.$moment().subtract(recentDays, 'days');
        };
      }
      if (valueType === 'numberRange') {
        defaultProps.placeholder = placeholder || ['最小值', '最大值'];
      }
      return defaultProps;
    },
    // 获取最终的props配置，优先级：自定义 > 默认；局部 > 全局
    mergeProps(item, ...args) {
      const {
        valueType,
        valueEnum,
        ext = {}
      } = item;
      let targetFieldProps = this.getTargetValue('fieldProps', item);

      // infiniteSelect 支持通过 valueEnum 传值
      if (valueType === 'infiniteSelect' && valueEnum) {
        targetFieldProps = Object.assign(targetFieldProps || {}, {
          options: Object.keys(valueEnum).map(key => ({
            value: key,
            label: valueEnum[key]
          }))
        });
      }
      if (item.multiple) targetFieldProps.mode = 'multiple';
      return _.merge(this.getDefaultProps(item), targetFieldProps, ext, ...args);
    },
    // select组件的搜索
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    // 获取formItem中的目标值，如果为function则返回请求后的结果
    getTargetValue(key, formItem, defaultValue = {}) {
      let value = formItem[key];
      if (typeof formItem[key] === 'function') value = formItem[key](this.targetParams);
      return value !== undefined ? value : defaultValue;
    },
    /**
     * @description: 把Form配置转换成最终提供给接口使用的参数
     * @param {Array} items props.items
     * @return {object} { key或dataIndex对应的字段名: 'value值' }
     */
    getResult(items) {
      const rawParams = {};
      items.forEach(item => rawParams[item.key] = item.value);
      let obj = {};
      items.map(item => {
        const {
          valueType
        } = item;
        let defaultTransform = value => value;
        if (valueType === 'dateRange') {
          // 日期选择器的默认转换
          defaultTransform = (value = []) => {
            const [value0, value1] = value;
            const format = this.getTargetValue('fieldProps', item).format || item.format || 'YYYY-MM-DD';
            // 如果需要返回两个不同的字段，dataIndex可以设置为数组，如:['startDate', 'endDate']，将返回 {startDate:'2022-08-19', endDate: '2022-08-20'}
            if (Array.isArray(item.dataIndex)) {
              const [startDate, endDate] = item.dataIndex;
              const resObj = {};
              resObj[startDate] = value0 ? this.$moment(value0).format(format) : undefined;
              resObj[endDate] = value1 ? this.$moment(value1).format(format) : undefined;
              return resObj;
            }
            // 否则返回数组 ['2022-08-19', '2022-08-20']
            return value.length === 0 ? [] : [this.$moment(value0).format(format), this.$moment(value1).format(format)];
          };
        } else if (valueType === 'numberRange') {
          // 数字选择器的默认转换
          defaultTransform = (value = []) => {
            const [value0, value1] = value;
            // 如果需要返回两个不同的字段，dataIndex可以设置为数组，如:['min', 'max']，将返回 {min:1, max: 100}
            if (Array.isArray(item.dataIndex)) {
              const [min, max] = item.dataIndex;
              const resObj = {};
              resObj[min] = value0 === null ? undefined : value0;
              resObj[max] = value1 === null ? undefined : value1;
              return resObj;
            }
            // 否则返回数组 [1, 2]
            return value;
          };
        } else if (valueType === 'shopLevel') {
          // v-model="item.value" 返回的数据包括店铺(shop_)和层级(biz_)的，默认情况只需返回店铺数据
          // 店铺层级的默认转换
          defaultTransform = value => {
            if (Array.isArray(value)) {
              const shops = value.filter(_value => _value.startsWith('shop_')).map(_value => _value.split('_')[1]);
              const bizs = value.filter(_value => _value.startsWith('biz_')).map(_value => _value.split('_')[1]);
              // 如果有店铺则只返回店铺，否则返回层级
              const targetRes = shops.length > 0 ? shops.toString() : bizs.toString();
              return targetRes || undefined;
            }
            return value ? value.split('_')[1] : value;
          };
        } else if (valueType === 'select') {
          defaultTransform = value => {
            return item.returnString ? value?.toString() : value;
          };
        } else if (valueType === 'costSelect') {
          defaultTransform = value => {
            if (Array.isArray(value)) {
              return value.map(v => {
                return v.replaceAll(/item_|class_/g, '');
              });
            }
            return value ? value.replaceAll(/item_|class_/g, '') : '';
          };
        }
        const {
          transform = defaultTransform
        } = item;
        const res = transform(item.value || undefined, rawParams);

        // 如果返回对象，则把对象合并到obj中作为参数使用
        if (Object.prototype.toString.call(res) === '[object Object]') {
          obj = _.merge(obj, res);
        } else {
          obj[item.key || item.dataIndex] = res;
        }
      });
      return obj;
    },
    // 店铺层级组件初始化
    handleShopLevelReady({
      value,
      isBiz
    }, index) {
      if (!value) return;
      let _value = value;
      if (!Array.isArray(value)) {
        // 单选时没有返回biz_或shop_前缀
        _value = isBiz ? `biz_${value}` : `shop_${value}`;
      }
      this.shopLevelCacheMap[index] = _value;
    },
    // 选择科目改变时
    handleItemChange(e, item) {
      item.value = [e.value];
      item.defaultValue = e.value;

      // 更新参数
      this.targetParams = this.getResult(this.validItems);
    }
  }
};